import { graphql, useStaticQuery } from 'gatsby'

export const useSdkItems = () => {
	/** @type {UseSdkItemsQueryResult} */
	const { sdkYaml } = useStaticQuery(query)

	return {
		defaultPlatform: sdkYaml.default,
		sdkItems: mapPlatforms(sdkYaml.platforms),
	}
}

const query = graphql`
	query UseSdkItemsQuery {
		sdkYaml {
			default
			platforms {
				id
				label
				latest
				versions {
					file {
						childVersionYaml {
							platform
							version
							content {
								file {
									...FileFields
								}
								content {
									title
									file {
										...FileFields
									}
								}
							}
						}
					}
				}
			}
		}
	}

	fragment FileFields on File {
		childMdx {
			slug
			frontmatter {
				title
			}
		}
	}
`

/** @param {Platform[]} platforms */
const mapPlatforms = platforms =>
	Object.fromEntries(platforms.map(p => [p.id, { ...p, versions: mapVersions(p.versions || []) }]))

/** @param {PlatformVersionFile[]} versions */
const mapVersions = versions =>
	Object.fromEntries(
		versions.map(
			({
				file: {
					childVersionYaml: { content, version },
				},
			}) => [version, content?.map(getContent)],
		),
	)

/** @param {Content} */
function getContent({ content, file, title }) {
	if (file)
		return {
			items: content?.map(getContent),
			title: file.childMdx.frontmatter.title,
			type: content ? 'GROUP' : 'ITEM',
			url: `/${file.childMdx.slug}`,
		}

	if (title)
		return {
			title,
			type: 'TITLE',
		}
}

/**
 * @typedef {Object} UseSdkItemsQueryResult
 * @property {string} default
 * @property {Object} sdkYaml
 * @property {Platform[]} sdkYaml.platforms
 */

/**
 * @typedef {Object} Platform
 * @property {string} id
 * @property {string} label
 * @property {string} latest
 * @property {PlatformVersionFile[]} versions
 */

/**
 * @typedef {Object} PlatformVersionFile
 * @property {Object} file
 * @property {Version} file.childVersionYaml
 */

/**
 * @typedef {Object} Version
 * @property {string} platform
 * @property {string} version
 * @property {Content[]} content
 */

/**
 * @typedef {Object} Content
 * @property {Content[]} content
 * @property {File} file
 * @property {string} title
 */

/**
 * @typedef {Object} File
 * @property {Object} file.childMdx
 * @property {Object} file.childMdx.frontmatter
 * @property {string} file.childMdx.frontmatter.title
 */
